import '../scss/frontend.scss';
import Popup from './parts/popup-window';
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    popupInstance.init();
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    });
    {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    }
}
window.document.addEventListener('DOMContentLoaded', ready);
